import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectDeviceGroups } from 'redux/selectors';
import Modal from 'components/shared/Modal/Modal';
import ActionDevicesTable from 'components/features/ActionDevicesTable/ActionDevicesTable';
import './ViewDevicesListModal.css';

const ViewDevicesListModal = (props) => {
  const { afterModalClose, animateModalClose, closeModal, localSelectedDeviceGroupName } = props;
  const deviceGroups = useSelector(selectDeviceGroups);
  const [localSelectedDevicesDictionary, setLocalSelectedDevicesDictionary] = useState(null);

  useEffect(() => {
    let deviceGroupDevices = deviceGroups[localSelectedDeviceGroupName]?.devices;
    let newLocalSelectedDevicesDictionary = {};
    deviceGroupDevices &&
      deviceGroupDevices.forEach((deviceId) => {
        if (!localSelectedDevicesDictionary) {
          newLocalSelectedDevicesDictionary[deviceId] = { checked: true, matched: true };
        } else {
          if (localSelectedDevicesDictionary[deviceId]) {
            newLocalSelectedDevicesDictionary[deviceId] = localSelectedDevicesDictionary[deviceId];
          } else {
            newLocalSelectedDevicesDictionary[deviceId] = { checked: true, matched: true };
          }
        }
      });
    setLocalSelectedDevicesDictionary(newLocalSelectedDevicesDictionary);
  }, [deviceGroups]);

  return (
    <Modal
      close={afterModalClose} //note that this only runs if you close the modal using the "closing" prop
      animate={animateModalClose}
      animateX={false}
      global
      closing={closeModal}
      noPadding
      height={696}
      width={780}
    >
      <div className="ViewDevicesListModal">
        <div className="ViewDevicesListModal_HeaderDiv">
          <div
            className="ViewDevicesListModal_HeaderDiv_Title"
            data-tip={localSelectedDeviceGroupName ? localSelectedDeviceGroupName : 'All devices'}
          >
            {localSelectedDeviceGroupName ? localSelectedDeviceGroupName : 'All devices'}
          </div>
        </div>
        <ActionDevicesTable
          localDeviceGroupName={localSelectedDeviceGroupName}
          width={'auto'}
          hasCheckBox={false}
          hasRemoveButtons={true}
          localSelectedDevicesDictionary={localSelectedDevicesDictionary}
          setLocalSelectedDevicesDictionary={setLocalSelectedDevicesDictionary}
          deviceGroups={deviceGroups}
        />
      </div>
    </Modal>
  );
};

export default React.memo(ViewDevicesListModal);
